import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c5bc75f8&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c5bc75f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bc75f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5bc75f8')) {
      api.createRecord('c5bc75f8', component.options)
    } else {
      api.reload('c5bc75f8', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c5bc75f8&scoped=true&", function () {
      api.rerender('c5bc75f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/comp/PopupBox.vue"
export default component.exports